import { render, staticRenderFns } from "./PostWallIcon.vue?vue&type=template&id=6bf36f90&"
import script from "./PostWallIcon.vue?vue&type=script&lang=js&"
export * from "./PostWallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports